import { api } from '../../../../../lib/api';
import { SCALE_SATISFACTION } from '../../../../../lib/utils/constants/FeedbackTypes';

/**
 * Sends the final star value, and the comment when one was written, in a
 * single request. The server keeps one row per user per campaign, so this is
 * safe to call again if the modal is ever shown twice.
 *
 * @param {{ rate: number, textRating?: string, campaignUuid: string }} feedback
 */
export const createUserFeedback = ({ rate, textRating, campaignUuid }) => {
  const feedbackMessage = textRating?.trim();

  return api({
    method: 'post',
    url: '/api/campaign_user_feedbacks',
    data: {
      campaign_user_feedback: {
        feedback_type: SCALE_SATISFACTION,
        feedback: rate,
        campaign_id: campaignUuid,
        ...(feedbackMessage ? { feedback_message: feedbackMessage } : {}),
      },
    },
  });
};
